import SoftwareHouseService from "@/services/SoftwareHouseService";

export const softwareHouse = {
  namespaced: true,
  state: {
    softwareHouse: {},
  },
  actions: {
    getSoftwareHouse({ commit }, payload) {
      return SoftwareHouseService.GetSoftwareHouse(payload).then(
        (softwareHouse) => {
          return Promise.resolve(softwareHouse);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postSoftwareHouse({ commit }, payload) {
      return SoftwareHouseService.PostSoftwareHouse(payload).then(
        (softwareHouse) => {
          return Promise.resolve(softwareHouse);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putSoftwareHouse({ commit }, payload) {
      return SoftwareHouseService.PutSoftwareHouse(payload).then(
        (softwareHouse) => {
          return Promise.resolve(softwareHouse);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteSoftwareHouse({ commit }, payload) {
      return SoftwareHouseService.DeleteSoftwareHouse(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getSoftwareHouseOData({ commit }, payload) {
      return SoftwareHouseService.GetSoftwareHouseOData(payload).then(
        (softwareHouse) => {
          return Promise.resolve(softwareHouse);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default softwareHouse;
